import { Field, FinalFormInput } from "@comet/admin";
import { type VividFieldProps } from "@src/components/fields/interfaces";
import { type FC, type PropsWithChildren } from "react";

export const InputTextAreaField: FC<PropsWithChildren<VividFieldProps>> = ({ variant, label, ...rest }) => {
    const effectiveVariant = variant ?? (label ? "horizontal" : "vertical");
    return (
        <Field component={FinalFormInput} rows={4} multiline fullWidth fieldContainerProps={{ variant: effectiveVariant }} label={label} {...rest} />
    );
};
